import Styles from "./MessageWindow.module.scss";
import classnames from "classnames"
import Picker from 'emoji-picker-react';

//Icons
import { ReactComponent as InfoIcon } from "../../../icons/extra_icons/info.svg"
import { ReactComponent as VideoIcon } from "../../../icons/extra_icons/videocall.svg"
import { ReactComponent as AttachmentIcon } from "../../../icons/extra_icons/appstore_attachment.svg"
import { ReactComponent as MobileAttachmentIcon } from "../../../icons/extra_icons/mobile_attachment.svg"
import { ReactComponent as EmojisIcon } from "../../../icons/extra_icons/emojis.svg"
import { ReactComponent as SendIcon } from "../../../icons/extra_icons/send.svg"
import { ReactComponent as LogoutIcon } from "../../../icons/extra_icons/logout.svg"


import Tooltip from "../../tooltip/Tooltip";
import { getDateTimeFromTimestamp, getTimeDifferenceWithUnits } from "../../../global/functions/functrions";
import { useDispatch } from "react-redux";
import { openWindow } from "../../../actions";
import { APP_KEY_IDS } from "../../../constants/constants";
import Loader from "../../loader/Loader";
import { useContext, useEffect, useState } from "react";
import { collection, doc, getDocs, onSnapshot, orderBy, query, setDoc } from "firebase/firestore";
import { auth, firestore } from "../../../useFirebaseInit";
import { orderByValue } from "firebase/database";
import { URL_TYPE } from "../../../constants/standardWords";
import { generateRandomString } from "../../../global/functions/firebaseFunctions";
import { signOut } from "firebase/auth";
import { AuthContext } from "../../../contexts/AuthContext";

interface MessageWindowprops {
  profileDetails: any
}

const MessageWindow = ({  profileDetails }: MessageWindowprops) => {

  const dispatch = useDispatch()

  const {userId,setUser, isLoggedIn} = useContext(AuthContext)

  const [chats, setChats] = useState([])
  const [isPickerVisible, setIsPickerVisible] = useState(false)
  const [inputMessage, setInputMessage] = useState<any>("")

  useEffect(() => {
    scrollToBottom()
  })

  useEffect(() => {
    getChats()
  }, [userId])

  const getChats = async () => {
    const q = query(collection(firestore, `users/${userId}/messages`), orderBy("createdAt", "asc"));

    const querySnapshot = await getDocs(q);

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const chatDocs: any = [];
      querySnapshot.forEach((doc: any) => {
        chatDocs.push({ id: doc.id, ...doc.data() });
      });
      setChats(chatDocs)
    });

  }


  const sendMessage = async () => {
    await setDoc(doc(firestore, `users/${userId}/messages`, generateRandomString() + "_" + String(Date.now())), {
      message: inputMessage,
      createdAt: Date.now(),
      uid: userId
    });
    scrollToBottom()
    setInputMessage("")
  }

  const onEmojiClick = async (event: any, emojiObject: any) => {
    await setDoc(doc(firestore, `users/${userId}/messages`, generateRandomString() + "_" + String(Date.now())), {
      message: emojiObject.srcElement.currentSrc,
      createdAt: Date.now(),
      messageType: URL_TYPE.EMOJI,
      uid: userId,
    });
    setIsPickerVisible(false)
  }

  const getMessage = (message: any) => {
    switch (message.messageType) {
      case URL_TYPE.EMOJI: return <img src={message.message} className={Styles.emoji} />
      default: return (
        message.message
      )
    }
  }
 
  const scrollToBottom =() =>{
    
    var objDiv = document.getElementById("chat_container");
    if(objDiv){
      objDiv.scrollTop = objDiv.scrollHeight;
    }
  }

  const logout = () => {
    signOut(auth).then(() => {
      setUser({
        userName: "",
        userId: "-1",
        pfpUrl: "",
        email: "",
        isEmailVerified: ""
      })
    }).catch((error) => {
    });
  }

  return (
    <div className={Styles.container}>
      <div className={Styles.top_bar}>
        <div className={Styles.pfp}><img src={profileDetails.icon} /></div>
        <div className={Styles.to}>To : </div>
        <div className={Styles.label}>{profileDetails.label}</div>
        <div className={Styles.options}>
          <VideoIcon />
          <InfoIcon onClick={() => { dispatch(openWindow(APP_KEY_IDS.CONTACTS)) }} />
        </div>
        <LogoutIcon onClick={logout} />
      </div>
      <div className={Styles.chat_container} id="chat_container">

        {
          chats
            ? <>
              <div className={Styles.day_header}>
                Today
              </div>
              {chats.map((message: any, index: number) => {
                return (
                  <div key={index}>
                    <div className={Styles.message_container} key={message.createdAt}>
                      <div className={classnames(Styles.message, Styles[message.messageType + "_container"])} id={message.uid != userId ? Styles.recieved : Styles.sent}>
                        <Tooltip
                          children={
                            getMessage(message)
                          }
                          text={getDateTimeFromTimestamp(message.createdAt)}
                        />
                      </div>
                    </div>
                    {
                      index === chats.length - 1 && message.uid === userId &&
                      <div className={Styles.status}>
                        Delievered
                      </div>
                    }
                  </div>
                )
              })}
            </>
            : <Loader />
        }

      </div>
      <div className={Styles.bottom_bar}>
        <div className={classnames(Styles.icon_container, Styles.desktop)}>
          <AttachmentIcon />
        </div>
        <div className={classnames(Styles.icon_container, Styles.mobile)}>
          <MobileAttachmentIcon />
        </div>
        <div className={Styles.message_input}>
          <textarea className={Styles.input} value={inputMessage} onChange={(e: any) => { setInputMessage(e.target.value) }} placeholder={"Type your message"} id={"message_input"} />
        </div>
        <div className={Styles.icon_container}>
          <EmojisIcon onClick={() => { setIsPickerVisible(!isPickerVisible) }} />
          {
            isPickerVisible &&
            <div className={Styles.emoji_picker}>
              <Picker onEmojiClick={onEmojiClick} />
            </div>
          }
        </div>
        {
          inputMessage &&
          <button className={classnames(Styles.icon_container, Styles.send_button, !(userId && inputMessage) && Styles.disabled)} onClick={sendMessage} disabled={!(isLoggedIn && inputMessage)}>
            <SendIcon />
          </button>
        }
      </div>
    </div >
  )
}

export default MessageWindow
